export default __webpack_public_path__ + "static/media/ReactLogo.7db1dac7.svg";